<template>
  <v-card :loading="loading">
    <v-form>
      <v-container>
        <fieldset>
          <v-row>
            <v-col cols="12">
              <non-form-field-errors :errors="errors"></non-form-field-errors>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Name</label>
              <v-text-field
                v-model="data.group_name"
                :error-messages="errors.group_name"
                label="Group Name"
                placeholder="Group Name"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" v-if="false">
              <label class="custom-label">Choose Class</label>
              <v-select
                :error-messages="errors.class_name_id"
                v-model="data.class_name_id"
                :items="classes"
                label="Choose Class"
                placeholder="Choose Class"
                solo
                single-line
                item-value="class_id"
                item-text="class_name"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Choose Tutor</label>
              <v-autocomplete
                :error-messages="errors.tutor_id"
                v-model="data.tutor_id"
                :items="tutors"
                solo
                label="Tutor"
                placeholder="Tutor"
                :search-input.sync="tutor_search"
              >
              </v-autocomplete>
            </v-col>

            <!-- <v-col cols="12" sm="6" md="6">
                            <label class="custom-label">Choose Days</label>
                            <v-select
                                    :error-messages="errors.days"
                                    v-model="data.days"
                                    :items="days"
                                    label="Choose Days"
                                    placeholder="Choose Days"
                                    solo
                                    multiple
                            ></v-select>
                        </v-col> -->
            <v-col cols="12" sm="6" md="6" v-if="false">
              <label class="custom-label">Choose Subject</label>
              <v-select
                :error-messages="errors.subject_id"
                v-model="data.subject_id"
                :items="$store.getters.subjectsSelect"
                label="Choose Subject"
                placeholder="Choose Subject"
                solo
                single-line
              ></v-select>
            </v-col>

            <!-- <v-col cols="12" sm="6" md="6">
                            <label class="custom-label">Start Time</label>
                            <v-menu
                                    ref="menu"
                                    v-model="startTimeMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="data.start_time"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            :error-messages="errors.start_time"
                                            v-model="data.start_time"
                                            label="Start Time"
                                            prepend-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            solo
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                        v-if="startTimeMenu"
                                        v-model="data.start_time"
                                        full-width
                                        @click:minute="$refs.menu.save(data.start_time)"
                                ></v-time-picker>
                            </v-menu>
                        </v-col> -->

            <!-- <v-col cols="12" sm="6" md="6">
                            <label class="custom-label">End Time</label>
                            <v-menu
                                    ref="menu2"
                                    v-model="endTimeMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="data.end_time"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            :error-messages="errors.end_time"
                                            v-model="data.end_time"
                                            label="End Time"
                                            prepend-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            solo
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                        v-if="endTimeMenu"
                                        v-model="data.end_time"
                                        full-width
                                        @click:minute="$refs.menu2.save(data.end_time)"
                                ></v-time-picker>
                            </v-menu>
                        </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn :loading="loading" color="primary" @click="save">Save</v-btn>
            </v-col>
          </v-row>
        </fieldset>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { DAYSSELECTOR } from "../../utils/constants";
import Form from "../../utils/form";
import NonFormFieldErrors from "../utils/errors/NonFormFieldErrors";

export default {
  name: "GroupForm",
  components: {
    NonFormFieldErrors,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      days: DAYSSELECTOR,
      data: {
        group_name: "",
        class_name_id: null,
        tutor_id: null,
        days: [],
        subject_id: null,
        start_time: "",
        end_time: "",
      },
      tutors: [],
      errors: {},
      classes: [],
      startTimeMenu: false,
      tutor_search: "",
      endTimeMenu: false,
    };
  },
  // watch: {
  //     "tutor_search"() {
  //         this.getTutors()
  //     }
  // },
  methods: {
    getTutors() {
      // console.log('tutors')
      axios
        .get(apiRoutes.groups.create, {
          params: {
            q: this.tutor_search,
          },
        })
        .then((response) => {
          // console.log(response.data.response)
          this.classes = response.data.classes;
          this.tutors = response.data.response.map((tutor) => {
            return {
              text: tutor.tutor_fname + " " + tutor.tutor_lname,
              value: tutor.tutor_id,
            };
          });
        });
    },
    save() {
      this.loading = true;
      if (this.id) {
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      let form = new Form({
        ...this.data,
      });
      form
        .post(apiRoutes.groups.url)
        .then((response) => {
          console.log(response);
          this.loading = false;
          // console.log(response.id)
          this.$router.replace({
            name: "Groups",
          });
        })
        .catch((response) => {
          if (response.status === 400) {
            this.errors = response.data;
          }
          if (response.status === 422) {
            this.errors = response.data.errors;
          }
          this.loading = false;
        });
    },
    update() {
      let form = new Form({
        ...this.data,
      });
      form
        .put(apiRoutes.groups.url + "/" + this.id)
        .then((response) => {
          this.loading = false;
          this.$router.replace({
            name: "Groups",
          });
        })
        .catch((response) => {
          if (response.status === 400) {
            this.errors = response.data;
          }
          this.loading = false;
        });
    },
  },
  created() {
    // console.log("this.$store.getters.classesSelect")

    // console.log(this.$store.getters.classes)
    this.loading = false;
    // alert(this.id)
    if (this.id) {
      // console.log('ssssss')
      axios.get(apiRoutes.groups.url + "/" + this.id).then((response) => {
        console.log(response.data.group_name);
        this.data.group_name = response.data.group_name;
        this.data.class_name_id = parseInt(response.data.class_id);
        this.data.tutor_id = parseInt(response.data.tutor_id);
        this.data.subject_id = parseInt(response.data.subject_id);
        // this.data.days = response.data.days
        // this.data.class_name_id = response.data.class_name.id
        // this.data.start_time = response.data.start_time
        // this.data.end_time = response.data.end_time
      });
    }
    this.getTutors();
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }

  & label {
    font: Bold 15px/40px Lato;
    color: #172b4d;
  }
}
</style>
